.content-container {
    container-type: size;
    position: relative;
    height: 100%;
    width: 100%;
}

.events-container {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
}

.message-input-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.message-input-wrapper {
    width: 95%;
    max-width: 800px;
}

.thread-summary-container {
    max-width: 800px;
    margin: 0 auto;
}
